<script>
export default {
    name: "CustomEdge",
    props: {
        sourceX: { type: Number, required: true },
        sourceY: { type: Number, required: true },
        targetX: { type: Number, required: true },
        targetY: { type: Number, required: true },
        label: { type: String, default: "" },
        isLoading: { type: Boolean, default: false },
        isHover: { type: Boolean, default: false },
    },
    data() {
        return {
            labelWidth: 60, // начальные значения
            labelHeight: 26,
            maxLabelWidth: 100,
        };
    },
    mounted() {
        this.updateLabelSize();
    },
    watch: {
        label() {
            this.updateLabelSize();
        }
    },
    methods: {
        updateLabelSize() {
            if (!this.label) return;

            // Создаем временный элемент для измерения
            const tempSpan = document.createElement('span');
            tempSpan.style.visibility = 'hidden';
            tempSpan.style.position = 'absolute';
            tempSpan.style.whiteSpace = 'nowrap';
            tempSpan.style.padding = '0 8px'; // Учитываем padding вашего div
            tempSpan.textContent = this.label;

            document.body.appendChild(tempSpan);

            // Получаем размеры с учетом padding и округляем
            this.labelWidth = Math.min(
                Math.max(tempSpan.offsetWidth, 40) + 10,
                this.maxLabelWidth
            );

            document.body.removeChild(tempSpan);
        }
    },
    computed: {
        midPoint() {
            const midX = (this.sourceX + this.targetX) / 2;
            const midY = (this.sourceY + this.targetY) / 2;
            return { x: midX, y: midY };
        },
        // Вычисляем контрольные точки для плавного изгиба
        controlPoints() {
            const offset = Math.abs(this.targetY - this.sourceY) / 2; // Динамический отступ
            return {
                c1x: this.sourceX + offset / 2,
                c1y: this.sourceY,
                c2x: this.targetX - offset / 4,
                c2y: this.targetY
            };
        },
        edgeStyle() {
            return this.isLoading
                ? {
                    strokeDasharray: "5, 5",
                    animation: "dashdraw 3s linear infinite",
                    stroke: "#3b82f6"

                }
                : {
                    strokeDasharray: "0",
                    animation: "none",
                    stroke: this.isHover ? "#3b82f6" : "#7d7a7a"
                };
        }
    }
}
</script>

<template>
    <g>
        <path
            fill="none"
            stroke-width="1.5"
            :d="`M${sourceX},${sourceY}
                 C${controlPoints.c1x},${controlPoints.c1y}
                  ${controlPoints.c2x},${controlPoints.c2y}
                  ${targetX},${targetY}`"
            :style="edgeStyle"
        />
        <foreignObject
            v-if="label !== ''"
            :x="midPoint.x - labelWidth / 2"
            :y="midPoint.y - labelHeight / 2"
            :width="labelWidth"
            :height="labelHeight"
            requiredExtensions="http://www.w3.org/1999/xhtml"
        >
            <div class="flex items-center justify-center h-full w-full bg-gray-400 rounded-md px-2">
                <span class="text-white text-xs truncate w-full text-center">
                  {{ label }}
                </span>
            </div>
        </foreignObject>
    </g>
</template>

<style>
@keyframes dashdraw {
    from {
        stroke-dashoffset: 0;
    }
    to {
        stroke-dashoffset: 8;
    }
}
</style>